import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { OrderHistory } from '../generic/classes/order.history';
import { Logger } from '../generic/logging/default-log.service';
import { OrderHistoryDetail } from '../generic/classes/order.history.detail';
import { BaseService } from '../generic/service/base.service';
import { HttpClient } from '../generic/service/http.service';
import { ConfigurationHelper } from '../generic/helper/configuration.helper';

/**
 * Order history service
 */
@Injectable()
export class OrderHistoryService extends BaseService {
    private http = inject(HttpClient);

    constructor() {
        const logger = inject(Logger);

        super(logger);
    }

    getOrderHistory(): Observable<OrderHistory[]> {
        const url = ConfigurationHelper.getWebshopUrl('/rest/order/history');

        return this.http.get<OrderHistory[]>(url);
    }

    getOrderHistoryDetail(
        orderId: string,
        addressCode: string,
        shipmentDate: string,
        sorting: string,
        sortingDirection: string,
    ): Observable<OrderHistoryDetail[]> {
        const params: Array<string> = [];

        params.push(`orderId=${orderId}`);
        params.push(`shipToCode=${encodeURIComponent(addressCode)}`);
        params.push(`shipmentDate=${shipmentDate}`);

        if (sorting && sortingDirection) {
            params.push(`sorting=${sorting}`);
            params.push(`sortingDirection=${sortingDirection}`);
        }

        const paramsJoined: string = params.join('&');

        const url = ConfigurationHelper.getWebshopUrl(
            '/rest/order/history/detail' + '?' + paramsJoined,
        );

        return this.http.get<OrderHistoryDetail[]>(url);
    }
}
